import { differenceInMinutes, endOfDay, isSameDay } from "date-fns";

import { RouteStats } from "@commons/models/domain/RouteStats";
import { RouteSummaryStats } from "../interfaces/route-stats.interface";
import { RouteEvent } from "@commons/models/domain/RouteEvent";
import { RouteElementTypeEnum } from "@commons/enums/route-element-type.enum";
import { formatMinutesToHours } from "./date";

export const CalculateRouteSummaryParamsByStats = (data: RouteStats): RouteSummaryStats => {
    return {
        distance: data.D,
        time: Math.floor(data.T / 60),
        fuel: data.F,
        fuelPer100: (data.D === 0) ? 0 : ((data.F / data.D) * 100), 
    }
};

// onlySameDay - podliczaj tylko te postoje, których start_date jest taki sam jak end_date, w przeciwnym razie end_date ustaw na koniec dnia
export function calculateFullStopTimeRoutes(routeData: RouteEvent[], onlySameDay?: boolean): string {
    const stopsPoints = routeData.filter(item => {
      const ifPointHasStartAndEndDate = item.St && item.En;
      return item.T === RouteElementTypeEnum.Stop && ifPointHasStartAndEndDate;
    });
    const totalMinutes = stopsPoints.reduce((acc, stop) => {
      const startDate = new Date(stop.St);
      const endDateRaw = new Date(stop.En);
      const isSameDayFlag = isSameDay(startDate, endDateRaw);

      // const computedEndDate = onlySameDay 
      //   ? (isSameDayFlag ? endDateRaw : endOfDay(startDate))
      //   : endDateRaw;
      
      return acc + differenceInMinutes(endDateRaw, startDate);      
    }, 0);
    return formatMinutesToHours(totalMinutes);
};

export function calculateStopTimeRoute(route: RouteEvent, routesArr: RouteEvent[], index: number): number {
  const stopPointData = routesArr[index + 1];

  if (stopPointData?.T === RouteElementTypeEnum.Stop && (stopPointData.St && stopPointData.En)) {
    const startDate = new Date(stopPointData.St);
    const isSameDayStartEndDate = stopPointData.En ? isSameDay(startDate, new Date(stopPointData.En)) : false;
    // const endDate = isSameDayStartEndDate ? new Date(stopPointData.En) : endOfDay(startDate); Wylicza czas do konca dnia, jesli endDate to inny dzien
    const endDate = new Date(stopPointData.En); // Niezalezenie od tego, czy endDate to inny dzien, to wylicza czas postoju calkowity
    const diffMinutes = differenceInMinutes(endDate, startDate);
    return diffMinutes === 0 ? 1 : diffMinutes;
  }

  return null!;
};
